"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var TopBarContainer = (0, _core.styled)("div")(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    backgroundColor: "#000"
  }, theme.breakpoints.down("sm"), {
    paddingTop: 2,
    paddingBottom: 2
  });
});
var Wrapper = (0, _core.styled)(_core.Box)({
  display: "flex",
  justifyContent: "flex-end",
  flexWrap: "wrap",
  padding: 4
});
var RowWrapper = (0, _core.styled)(_core.Box)({
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  padding: 4,
  flexDirection: "row",
  "& > div": {
    flex: 1
  }
});
var StyledLink = (0, _core.styled)("div")(function (_ref3) {
  var theme = _ref3.theme;
  return _defineProperty({
    color: "#fff",
    fontSize: "14px",
    fontWeight: 500,
    marginLeft: 20,
    lineHeight: 1.5
  }, theme.breakpoints.down("sm"), {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    marginLeft: 0,
    textAlign: "center"
  });
});
var StyledDivider = (0, _core.styled)(_core.Divider)(function (_ref5) {
  var theme = _ref5.theme;
  return {
    backgroundColor: "rgba(255,255,255,0.6)"
  };
});
var TopBar = function TopBar(_ref6) {
  var LinkComponent = _ref6.LinkComponent,
    links = _ref6.links;
  // we have a mobile version of links, which is just the text until the first : in the name
  var mobileLinks = links.map(function (link) {
    return {
      name: link.name.split(":")[0],
      path: link.path
    };
  });
  return /*#__PURE__*/_react["default"].createElement(TopBarContainer, null, /*#__PURE__*/_react["default"].createElement(_core.Hidden, {
    implementation: "css",
    xsDown: true
  }, /*#__PURE__*/_react["default"].createElement(_core.Container, null, /*#__PURE__*/_react["default"].createElement(Wrapper, null, links.map(function (link, i) {
    return link.path && link.path !== "" ? /*#__PURE__*/_react["default"].createElement(StyledLink, {
      key: i
    }, /*#__PURE__*/_react["default"].createElement(LinkComponent, {
      color: "inherit",
      to: link.path
    }, link.name, " ")) : /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      key: i,
      component: StyledLink
    }, link.name);
  })))), /*#__PURE__*/_react["default"].createElement(_core.Hidden, {
    implementation: "css",
    smUp: true
  }, /*#__PURE__*/_react["default"].createElement(RowWrapper, null, mobileLinks.map(function (link, i) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: i
    }, /*#__PURE__*/_react["default"].createElement(StyledLink, null, /*#__PURE__*/_react["default"].createElement(LinkComponent, {
      color: "inherit",
      to: link.path
    }, link.name)), i < mobileLinks.length - 1 && /*#__PURE__*/_react["default"].createElement(StyledDivider, {
      orientation: "vertical",
      flexItem: true
    }));
  }))));
};
var _default = exports["default"] = TopBar;